import { Chevron } from '@factorialco/deprecated-design-system'

import { Document } from 'modules/documents/hooks/documents/useGetDocuments'

interface Props {
  documents: Document[]
  onClick: () => void
}

const LeftChevron = ({ documents, onClick }: Props) => {
  if (documents.length <= 1) return null

  return (
    <button onClick={onClick}>
      <Chevron direction="left" type="secondary" />
    </button>
  )
}

export default LeftChevron
